import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Profile() {
  const { user, setUser } = useAuth();
  const { t } = useLang();
  useSEO("Profile");
  const [form, setForm] = useState({
    name: user?.name || "", telegram_username: user?.telegram_username || "",
    phone: user?.phone || "", country: user?.country || "",
  });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success("Profile updated");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl font-bold text-white">{t("profile")}</h1>
      <div className="card-surface rounded-2xl p-7 max-w-2xl">
        <div className="flex items-center gap-4 mb-6 pb-6 border-b border-white/10">
          <div className="h-16 w-16 rounded-full gradient-brand flex items-center justify-center text-brand-navy text-2xl font-bold">{(user?.name || "U").charAt(0).toUpperCase()}</div>
          <div>
            <p className="font-display font-semibold text-white text-lg">{user?.name}</p>
            <p className="text-sm text-slate-500">{user?.email}</p>
            <p className="text-xs text-slate-600 mt-1">Signed in via {user?.auth_provider === "google" ? "Google" : "Email"}</p>
          </div>
        </div>
        <form onSubmit={save} className="space-y-4" data-testid="profile-form">
          <div><Label className="text-slate-300">{t("name")}</Label><Input value={form.name} onChange={set("name")} data-testid="profile-name" className="mt-1.5 bg-white/5 border-white/10" /></div>
          <div><Label className="text-slate-300">Telegram Username</Label><Input value={form.telegram_username} onChange={set("telegram_username")} data-testid="profile-telegram" placeholder="@username" className="mt-1.5 bg-white/5 border-white/10" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><Label className="text-slate-300">Phone</Label><Input value={form.phone} onChange={set("phone")} data-testid="profile-phone" className="mt-1.5 bg-white/5 border-white/10" /></div>
            <div><Label className="text-slate-300">Country</Label><Input value={form.country} onChange={set("country")} data-testid="profile-country" className="mt-1.5 bg-white/5 border-white/10" /></div>
          </div>
          <Button type="submit" disabled={loading} data-testid="profile-save" className="gradient-brand text-brand-navy font-semibold">{loading ? t("loading") : t("save")}</Button>
        </form>
      </div>
    </div>
  );
}
